module.exports = __webpack_public_path__ + "images/volvocarlease84da9f3aa20933b9d70666d69257f069.png";